
// Progress Bar
window.addEventListener('scroll',function(){
var h=document.documentElement;
var b=document.body;
var st=h.scrollTop||b.scrollTop;
var sh=h.scrollHeight||b.scrollHeight;
var ch=h.clientHeight;
var pct=(st/(sh-ch))*100;
document.getElementById('progressBar').style.width=pct+'%';
});

// Scroll Fade-In
function revealOnScroll(){
var els=document.querySelectorAll('.fade-in');
for(var i=0;i<els.length;i++){
var rect=els[i].getBoundingClientRect();
if(rect.top<window.innerHeight-60){
els[i].classList.add('visible');
}
}
}
window.addEventListener('scroll',revealOnScroll);
window.addEventListener('load',revealOnScroll);
